/* =============================================
   Philip Schuerk Art — Theme JS
   ============================================= */

(function() {
  'use strict';

  /* --- Scroll Animations --- */
  function initAnimations() {
    var elements = document.querySelectorAll('[data-animate]');
    if (!elements.length) return;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -40px 0px'
    });

    elements.forEach(function(el) { observer.observe(el); });
  }

  /* --- Header Scroll --- */
  function initHeader() {
    var header = document.querySelector('[data-header]');
    if (!header) return;

    var scrolled = false;
    window.addEventListener('scroll', function() {
      var shouldScroll = window.scrollY > 20;
      if (shouldScroll !== scrolled) {
        scrolled = shouldScroll;
        header.classList.toggle('has-scrolled', scrolled);
      }
    }, { passive: true });
  }

  /* --- Mobile Menu --- */
  function initMobileMenu() {
    var toggle = document.querySelector('[data-menu-toggle]');
    var nav = document.querySelector('[data-mobile-nav]');
    if (!toggle || !nav) return;

    toggle.addEventListener('click', function() {
      var isOpen = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen);
    });
  }

  /* --- Cart Drawer --- */
  function initCartDrawer() {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;

    var toggles = document.querySelectorAll('[data-cart-toggle]');
    var closers = document.querySelectorAll('[data-cart-close]');

    function openDrawer(e) {
      e.preventDefault();
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    toggles.forEach(function(el) { el.addEventListener('click', openDrawer); });
    closers.forEach(function(el) { el.addEventListener('click', closeDrawer); });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
        closeDrawer();
      }
    });
  }

  /* --- Product Page: Image Gallery --- */
  function initProductGallery() {
    var images = document.querySelectorAll('[data-image-index]');
    var prevBtn = document.querySelector('[data-gallery-prev]');
    var nextBtn = document.querySelector('[data-gallery-next]');
    var counter = document.querySelector('[data-gallery-current]');
    if (images.length <= 1) return;

    var current = 0;

    function goTo(index) {
      images[current].classList.remove('is-active');
      current = (index + images.length) % images.length;
      images[current].classList.add('is-active');
      if (counter) counter.textContent = current + 1;
    }

    if (prevBtn) prevBtn.addEventListener('click', function() { goTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function() { goTo(current + 1); });

    var gallery = document.querySelector('[data-product-gallery]');
    if (gallery) {
      var touchStartX = 0;
      gallery.addEventListener('touchstart', function(e) { touchStartX = e.touches[0].clientX; }, { passive: true });
      gallery.addEventListener('touchend', function(e) {
        var diff = touchStartX - e.changedTouches[0].clientX;
        if (Math.abs(diff) > 50) {
          if (diff > 0) goTo(current + 1); else goTo(current - 1);
        }
      }, { passive: true });
    }
  }

  /* --- Product Page: Variant Selection --- */
  function initVariantSelector() {
    var productJson = document.querySelector('[data-product-json]');
    if (!productJson) return;

    var product;
    try {
      product = JSON.parse(productJson.textContent);
    } catch(e) {
      return;
    }

    var optionBtns = document.querySelectorAll('[data-option-index]');
    var variantInput = document.querySelector('[data-variant-id]');
    var priceEl = document.querySelector('[data-product-price]');
    var addBtn = document.querySelector('.product-main__add-btn');

    var selectedOptions = product.options.map(function(_, i) {
      var active = document.querySelector('[data-option-index="' + i + '"].is-active');
      return active ? active.getAttribute('data-value') : '';
    });

    optionBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var optionIndex = this.getAttribute('data-option-index');
        var value = this.getAttribute('data-value');
        selectedOptions[optionIndex] = value;

        var siblings = document.querySelectorAll('[data-option-index="' + optionIndex + '"]');
        siblings.forEach(function(s) { s.classList.remove('is-active'); });
        this.classList.add('is-active');

        var variant = product.variants.find(function(v) {
          return v.options.every(function(opt, i) {
            return opt === selectedOptions[i];
          });
        });

        if (variant && variantInput) {
          variantInput.value = variant.id;
          if (priceEl) {
            priceEl.textContent = formatMoney(variant.price);
          }
          if (addBtn) {
            if (variant.available) {
              addBtn.disabled = false;
              addBtn.textContent = 'In den Warenkorb';
              addBtn.classList.remove('btn--disabled');
            } else {
              addBtn.disabled = true;
              addBtn.textContent = 'Ausverkauft';
              addBtn.classList.add('btn--disabled');
            }
          }
        }
      });
    });
  }

  function formatMoney(cents) {
    return (cents / 100).toLocaleString('de-DE', {
      style: 'currency',
      currency: 'EUR'
    });
  }

  /* --- Hero Slider --- */
  function initHeroSlider() {
    var slider = document.querySelector('[data-hero-slider]');
    if (!slider) return;

    var slides = slider.querySelectorAll('[data-slide]');
    var dots = slider.querySelectorAll('[data-dot]');
    var prevBtn = slider.querySelector('[data-slide-prev]');
    var nextBtn = slider.querySelector('[data-slide-next]');
    var progressBar = slider.querySelector('[data-progress-bar]');

    if (slides.length <= 1) return;

    var current = 0;
    var autoplaySpeed = 5000;
    var timer = null;

    function goTo(index) {
      slides[current].classList.remove('is-active');
      if (dots.length) dots[current].classList.remove('is-active');

      current = (index + slides.length) % slides.length;

      slides[current].classList.add('is-active');
      if (dots.length) dots[current].classList.add('is-active');

      startProgress();
    }

    function next() { goTo(current + 1); }
    function prev() { goTo(current - 1); }

    function startProgress() {
      if (!progressBar) return;
      progressBar.classList.remove('is-animating');
      progressBar.style.width = '0%';

      requestAnimationFrame(function() {
        requestAnimationFrame(function() {
          progressBar.classList.add('is-animating');
          progressBar.style.transitionDuration = autoplaySpeed + 'ms';
          progressBar.style.width = '100%';
        });
      });
    }

    function startAutoplay() {
      stopAutoplay();
      timer = setInterval(next, autoplaySpeed);
      startProgress();
    }

    function stopAutoplay() {
      if (timer) clearInterval(timer);
    }

    if (nextBtn) nextBtn.addEventListener('click', function() { stopAutoplay(); next(); startAutoplay(); });
    if (prevBtn) prevBtn.addEventListener('click', function() { stopAutoplay(); prev(); startAutoplay(); });

    dots.forEach(function(dot) {
      dot.addEventListener('click', function() {
        stopAutoplay();
        goTo(parseInt(this.getAttribute('data-dot')));
        startAutoplay();
      });
    });

    var touchStartX = 0;
    slider.addEventListener('touchstart', function(e) {
      touchStartX = e.touches[0].clientX;
    }, { passive: true });

    slider.addEventListener('touchend', function(e) {
      var diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) {
        stopAutoplay();
        if (diff > 0) next(); else prev();
        startAutoplay();
      }
    }, { passive: true });

    startAutoplay();
  }

  /* --- Quantity Selector --- */
  function initQuantitySelector() {
    var minus = document.querySelector('[data-qty-minus]');
    var plus = document.querySelector('[data-qty-plus]');
    var input = document.querySelector('[data-qty-input]');
    if (!minus || !plus || !input) return;

    minus.addEventListener('click', function() {
      var val = parseInt(input.value) || 1;
      if (val > 1) input.value = val - 1;
    });

    plus.addEventListener('click', function() {
      var val = parseInt(input.value) || 1;
      input.value = val + 1;
    });
  }

  /* --- Share Button --- */
  function initShareButton() {
    var btn = document.querySelector('[data-share-btn]');
    if (!btn) return;

    btn.addEventListener('click', function() {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(window.location.href).then(function() {
          btn.textContent = 'Kopiert!';
          setTimeout(function() {
            btn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 12v8a2 2 0 002 2h12a2 2 0 002-2v-8"/><polyline points="16 6 12 2 8 6"/><line x1="12" y1="2" x2="12" y2="15"/></svg> Link kopieren';
          }, 2000);
        });
      }
    });
  }

  /* --- Back to Top --- */
  function initBackToTop() {
    var btn = document.querySelector('[data-back-to-top]');
    if (!btn) return;

    window.addEventListener('scroll', function() {
      btn.classList.toggle('is-visible', window.scrollY > 600);
    }, { passive: true });

    btn.addEventListener('click', function() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  /* --- Init --- */
  document.addEventListener('DOMContentLoaded', function() {
    initAnimations();
    initHeader();
    initMobileMenu();
    initCartDrawer();
    initHeroSlider();
    initProductGallery();
    initVariantSelector();
    initQuantitySelector();
    initShareButton();
    initBackToTop();
  });

})();
